/*
  DKY | Grid geser - posisi teks yang ikut skala layar.

  MASALAH YANG DIPERBAIKI
  Tulisan di dalam kotak grid diletakkan dengan padding PIKSEL TETAP
  (--info-pad-y / --info-pad-x, mis. 86px). Kotaknya sendiri melar mengikuti
  lebar layar, tapi 86px-nya tidak. Akibatnya letak teks terhadap gambar
  berubah-ubah di tiap ukuran layar - contoh nyata di homepage:
      layar 1280px -> kotak 627x564, teks 86px dari bawah = 15,3% tinggi
      layar 1600px -> kotak 787x708, teks 86px dari bawah = 12,2% tinggi

  CARA MEMPERBAIKI
  Angka piksel yang diatur di Theme Editor dibaca sekali, lalu ditulis ulang
  sebagai PERSEN dari kotaknya. Persen pada elemen absolut dihitung dari kotak
  induk, dan kotak grid rasionya tetap, jadi teks mendarat di titik yang sama
  di semua ukuran layar.

  Patokannya layar {DESKTOP} px (dan {MOBILE} px untuk HP): hasilnya persis
  seperti yang terlihat sekarang di layar itu, lalu ikut mengecil/membesar
  dengan mulus. Kalau letaknya terasa terlalu tinggi/rendah, ubah angka
  patokan di bawah ini - JANGAN ubah setelan di Theme Editor.

  Setelan di Theme Editor tetap berfungsi seperti biasa: skrip ini membaca
  apa pun yang sedang dipakai, jadi tidak ada angka yang dikunci di sini.

  CATATAN: kotak dengan kelas .dky-gg__info--above-like sengaja TIDAK diubah
  padding bawahnya, karena nilainya dipakai untuk menjaga teks tetap di atas
  tombol hati - dan tombol hati itu memang ukurannya piksel tetap.
*/
(function () {
  if (window.__dkyGgFluid) return;
  window.__dkyGgFluid = true;

  var DESKTOP_REF = 1280;  /* patokan layar desktop */
  var MOBILE_REF = 430;    /* patokan layar HP */
  var MOBILE_BP = 699;     /* sama dengan media query di section grid geser */

  var SEL = '.dky-gg__info, .dky-gg__info--btnonly';

  function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }

  function translateOf(cs) {
    var t = cs.transform;
    if (!t || t === 'none') return { x: 0, y: 0 };
    var m = t.match(/matrix\(([^)]+)\)/);
    if (!m) return { x: 0, y: 0 };
    var p = m[1].split(',');
    return { x: num(p[4]), y: num(p[5]) };
  }

  function apply(el) {
    var tile = el.parentElement;
    if (!tile) return;

    var box = tile.getBoundingClientRect();
    var vw = window.innerWidth || DESKTOP_REF;
    if (!box.width || !box.height || !vw) return;

    var mode = vw <= MOBILE_BP ? 'm' : 'd';
    var key = 'dkyFluid' + mode;

    /* Nilai asli dari Theme Editor dibaca sekali per tampilan (desktop / HP).
       Padding inline dikosongkan dulu supaya yang terbaca benar-benar nilai
       yang diatur, bukan persen hasil hitungan sebelumnya. */
    if (!el.dataset[key]) {
      el.style.paddingTop = '';
      el.style.paddingRight = '';
      el.style.paddingBottom = '';
      el.style.paddingLeft = '';
      el.style.transform = '';
      var raw = getComputedStyle(el);
      var mv = translateOf(raw);
      el.dataset[key] = [
        num(raw.paddingTop), num(raw.paddingRight),
        num(raw.paddingBottom), num(raw.paddingLeft),
        mv.x, mv.y
      ].join(',');
    }

    var v = el.dataset[key].split(',').map(num);
    var ref = mode === 'm' ? MOBILE_REF : DESKTOP_REF;

    /* Kotak melar lurus mengikuti lebar layar, jadi perbandingan ini tetap. */
    var kW = box.width / vw;
    var kH = box.height / vw;
    var refW = kW * ref;
    var refH = kH * ref;
    if (!refW || !refH) return;

    var pct = function (px) { return (px / refW * 100) + '%'; };

    el.style.paddingTop = pct(v[0]);
    el.style.paddingRight = pct(v[1]);
    el.style.paddingLeft = pct(v[3]);

    /* Teks di atas tombol hati: jarak bawahnya dibiarkan apa adanya. */
    if (!el.classList.contains('dky-gg__info--above-like')) {
      el.style.paddingBottom = pct(v[2]);
    }

    /* Geseran halus (nudge) juga dibuat proporsional. Persen pada translate
       dihitung dari ukuran elemen itu sendiri: X dari lebar, Y dari tinggi. */
    if (v[4] || v[5]) {
      el.style.transform = 'translate(' +
        (v[4] / refW * 100) + '%, ' +
        (v[5] / refH * 100) + '%)';
    }
  }

  function run() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }

  var t;
  function runSoon(delay) {
    clearTimeout(t);
    t = setTimeout(run, delay || 60);
  }

  function boot() {
    run();
    /* dky-gg-button.js membuat lapisan .dky-gg__info--btnonly setelah ini,
       jadi dijalankan sekali lagi. */
    runSoon(120);
    runSoon(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Ukurannya persen, jadi tidak perlu dihitung ulang saat layar diubah -
     kecuali saat melewati batas HP/desktop, karena nilainya memang beda. */
  var wasMobile = window.innerWidth <= MOBILE_BP;
  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth <= MOBILE_BP;
    if (isMobile !== wasMobile) {
      wasMobile = isMobile;
      runSoon(60);
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.querySelectorAll) {
      var list = el.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) {
        delete list[i].dataset.dkyFluidd;
        delete list[i].dataset.dkyFluidm;
      }
    }
    runSoon(80);
    runSoon(400);
  });
})();
